import { render, staticRenderFns } from "./CommandPalette.vue?vue&type=template&id=232c4acf&scoped=true&"
import script from "./CommandPalette.vue?vue&type=script&lang=js&"
export * from "./CommandPalette.vue?vue&type=script&lang=js&"
import style0 from "./CommandPalette.vue?vue&type=style&index=0&id=232c4acf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c4acf",
  null
  
)

export default component.exports